import './widget.scss';
import lodging from '../../assets/img/icons/lodging.svg';

function Money() {
  return (
    <div className="widget widget--grey">
      <img src={lodging} className="widget__icon" alt="Lodging" />
      <p className="widget__stat">
        <span>
          400,000<sup>+</sup>
        </span>
      </p>
      <p className="widget__text widget__text--larger">
        nights of lodging provided by The Salvation Army of Southern California in 2021
      </p>
    </div>
  );
}

export default Money;
